<template>
    <!--
    Sub header component.
    -->
    <div class="sub-header">
        <slot />
    </div>
</template>

<script>
export default
{
    name: 'SubHeader',
}
</script>



// WEBPACK FOOTER //
// SubHeader.vue?d1761994